import type { ProfileTemplateContentDto } from '@up2stay/up2promo-api-client';

type TemplateTextField = ProfileTemplateContentDto['jobTitle'];

/** OpenAPI types template text fields as records; backend stores plain strings. */
export function templateTextFieldToString(
  value: TemplateTextField | string | null | undefined,
): string | null {
  if (value == null) return null;
  if (typeof value === 'string') return value;
  return null;
}

export function stringToTemplateTextField(
  value: string | null | undefined,
): TemplateTextField | undefined {
  if (value == null || value === '') return undefined;
  return value as unknown as TemplateTextField;
}
